import React from 'react';
import { Button, Dropdown, Radio, Space, Typography, theme } from 'antd';
import { BgColorsOutlined } from '@ant-design/icons';
import { useDisplaySettings, ThemeMode, ContrastMode } from '../theme/DisplaySettingsContext';

const { Text } = Typography;
const { useToken } = theme;

export function DisplaySettingsMenu() {
  const { themeMode, contrastMode, setThemeMode, setContrastMode } = useDisplaySettings();
  const { token } = useToken();

  const dropdownContent = (
    <div
      style={{
        padding: 16,
        background: token.colorBgElevated,
        color: token.colorText,
        borderRadius: token.borderRadiusLG,
        boxShadow: token.boxShadowSecondary,
        minWidth: 220,
      }}
    >
      <Space direction="vertical" size="middle" style={{ width: '100%' }}>
        <div>
          <Text strong style={{ display: 'block', marginBottom: 8 }}>
            Theme
          </Text>
          <Radio.Group
            value={themeMode}
            onChange={e => setThemeMode(e.target.value as ThemeMode)}
            optionType="button"
            buttonStyle="solid"
            size="small"
          >
            <Radio.Button value="light">Light</Radio.Button>
            <Radio.Button value="dark">Dark</Radio.Button>
            <Radio.Button value="system">System</Radio.Button>
          </Radio.Group>
        </div>

        <div>
          <Text strong style={{ display: 'block', marginBottom: 8 }}>
            Contrast
          </Text>
          <Radio.Group
            value={contrastMode}
            onChange={e => setContrastMode(e.target.value as ContrastMode)}
            optionType="button"
            buttonStyle="solid"
            size="small"
          >
            <Radio.Button value="normal">Normal</Radio.Button>
            <Radio.Button value="high">High</Radio.Button>
            <Radio.Button value="system">System</Radio.Button>
          </Radio.Group>
        </div>
      </Space>
    </div>
  );

  return (
    <Dropdown dropdownRender={() => dropdownContent} trigger={['click']} placement="bottomRight">
      <Button
        type="text"
        icon={<BgColorsOutlined />}
        aria-label="Display settings"
        style={{ color: token.colorText }}
      />
    </Dropdown>
  );
}
